import { useState,useEffect } from "react";
import { SideMenu } from "./components/SideMenu";
import { Slide, ToastContainer } from "react-toastify";

const DefaultLayout = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <=1200);

    useEffect(() => {
        const handleResize = () => {
          setIsCollapsed(window.innerWidth <= 1200);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []); 

    const toggleSideMenu = () => {
        setIsCollapsed((prev) => !prev);
    };

    return (
        <>
            <ToastContainer transition={Slide} autoClose={2000} />
            <SideMenu isCollapsed={isCollapsed} toggleSideMenu={toggleSideMenu} />
            <main className={`main-content ${isCollapsed ? "side-menu--colapsed" : ""}`}>{children}</main>
        </>
    );
};

export default DefaultLayout;
